"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendMessageback;
exports.SEND_MESSAGE_BACK = void 0;
var SEND_MESSAGE_BACK = 'WEB_CHAT/SEND_MESSAGE_BACK';
exports.SEND_MESSAGE_BACK = SEND_MESSAGE_BACK;

function sendMessageback(value, text, displayText) {
  return {
    type: SEND_MESSAGE_BACK,
    payload: {
      displayText: displayText,
      text: text,
      value: value
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NlbmRNZXNzYWdlQmFjay5qcyJdLCJuYW1lcyI6WyJTRU5EX01FU1NBR0VfQkFDSyIsInNlbmRNZXNzYWdlYmFjayIsInZhbHVlIiwidGV4dCIsImRpc3BsYXlUZXh0IiwidHlwZSIsInBheWxvYWQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxpQkFBaUIsR0FBRyw0QkFBMUI7OztBQUVlLFNBQVNDLGVBQVQsQ0FBeUJDLEtBQXpCLEVBQWdDQyxJQUFoQyxFQUFzQ0MsV0FBdEMsRUFBbUQ7QUFDaEUsU0FBTztBQUNMQyxJQUFBQSxJQUFJLEVBQUVMLGlCQUREO0FBRUxNLElBQUFBLE9BQU8sRUFBRTtBQUFFRixNQUFBQSxXQUFXLEVBQVhBLFdBQUY7QUFBZUQsTUFBQUEsSUFBSSxFQUFKQSxJQUFmO0FBQXFCRCxNQUFBQSxLQUFLLEVBQUxBO0FBQXJCO0FBRkosR0FBUDtBQUlEIiwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU0VORF9NRVNTQUdFX0JBQ0sgPSAnV0VCX0NIQVQvU0VORF9NRVNTQUdFX0JBQ0snO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzZW5kTWVzc2FnZWJhY2sodmFsdWUsIHRleHQsIGRpc3BsYXlUZXh0KSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogU0VORF9NRVNTQUdFX0JBQ0ssXG4gICAgcGF5bG9hZDogeyBkaXNwbGF5VGV4dCwgdGV4dCwgdmFsdWUgfVxuICB9O1xufVxuXG5leHBvcnQgeyBTRU5EX01FU1NBR0VfQkFDSyB9O1xuIl19